export interface LevelProgress {
  level: number;
  totalPoints: number;
  pointsIntoLevel: number;
  pointsForNextLevel: number;
  pointsToNextLevel: number;
  currentLevelStartPoints: number;
  nextLevelAtPoints: number;
  progressPercent: number;
}

const BASE_LEVEL_POINTS = 1000;

export const getPointsRequiredForNextLevel = (level: number): number => {
  const normalizedLevel = Math.max(1, Math.floor(level || 1));
  return BASE_LEVEL_POINTS * (2 ** (normalizedLevel - 1));
};

export const calculateLevelProgress = (totalPointsInput: number): LevelProgress => {
  const totalPoints = Math.max(0, Math.floor(Number(totalPointsInput) || 0));
  let level = 1;
  let pointsIntoLevel = totalPoints;
  let currentLevelStartPoints = 0;
  let pointsForNextLevel = getPointsRequiredForNextLevel(level);

  while (pointsIntoLevel >= pointsForNextLevel) {
    pointsIntoLevel -= pointsForNextLevel;
    currentLevelStartPoints += pointsForNextLevel;
    level += 1;
    pointsForNextLevel = getPointsRequiredForNextLevel(level);
  }

  return {
    level,
    totalPoints,
    pointsIntoLevel,
    pointsForNextLevel,
    pointsToNextLevel: pointsForNextLevel - pointsIntoLevel,
    currentLevelStartPoints,
    nextLevelAtPoints: currentLevelStartPoints + pointsForNextLevel,
    progressPercent: pointsForNextLevel > 0 ? pointsIntoLevel / pointsForNextLevel : 0,
  };
};

export const resolveLevelProgress = (user?: { points?: number | null; levelProgress?: LevelProgress | null } | null): LevelProgress => {
  if (user?.levelProgress) return user.levelProgress;
  return calculateLevelProgress(user?.points ?? 0);
};
